
import { isTableColumnConfigDto, mergeTableColumnConfig, parseToColumnConfigDto, TableColumnConfig, TableColumnConfigDto, TableColumnConfigMerge, TableColumnConfigPayloadDto } from "./column/column-config.type";
import { isTableFilterConfigDto, mergeTableFilterConfig, parseToTableFilterConfigDto, TableFilterConfig, TableFilterConfigDto, TableFilterConfigMerge, TableFilterConfigPayloadDto } from "./filter/table-filter-config.type";

/**
 * Client-type of the TableConfig
 */
export interface TableConfig {
  readonly id: string;
  name: string;
  isDefault: boolean;
  isFavorite?: boolean;
  columnConfig: TableColumnConfig;
  filterConfig?: TableFilterConfig | undefined;
  options?: TableOptions | undefined;
}
/**
 * Server-type of the TableConfig
 */
export interface TableConfigDto {
  readonly configId?: number;
  configName: string;
  favourite: boolean;
  defaultConfig: boolean;
  columnConfigPayload: TableColumnConfigPayloadDto;
  filterConfigPayload?: TableFilterConfigPayloadDto | undefined;
}
export interface TableOptions {
  searchTerm: string;
}
export function parseToTableConfigDto (config: TableConfig): TableConfigDto {
  return { configName: config.name,
    favourite: Boolean(config.isFavorite),
    defaultConfig: config.isDefault,
    columnConfigPayload: parseToColumnConfigDto(config.columnConfig),
    filterConfigPayload: config.filterConfig ? parseToTableFilterConfigDto(config.filterConfig) : undefined };
}
export function mergeTableConfig (configDto: TableConfigDto, mergeBase: TableConfig): TableConfigMerge {
  const parsedFilterConfig: TableFilterConfigDto | undefined = configDto.filterConfigPayload?.configJson
    ? JSON.parse(configDto.filterConfigPayload.configJson) as TableFilterConfigDto
    : undefined;
  const filterConfigMerge: TableFilterConfigMerge | undefined = mergeBase.filterConfig && isTableFilterConfigDto(parsedFilterConfig)
    ? mergeTableFilterConfig(parsedFilterConfig, mergeBase.filterConfig)
    : undefined;
  const parsedColumnConfig: TableColumnConfigDto | undefined = configDto.columnConfigPayload.configJson
    ? JSON.parse(configDto.columnConfigPayload.configJson) as TableColumnConfigDto
    : undefined;
  const columnConfigMerge: TableColumnConfigMerge | undefined = isTableColumnConfigDto(parsedColumnConfig)
    ? mergeTableColumnConfig(parsedColumnConfig, mergeBase.columnConfig)
    : undefined;
  const tableConfig: TableConfig = {
    id: configDto.configId?.toString() ?? "",
    name: configDto.configName,
    isDefault: configDto.defaultConfig,
    isFavorite: configDto.favourite,
    filterConfig: filterConfigMerge ? filterConfigMerge.mergedConfig : undefined,
    columnConfig: columnConfigMerge ? columnConfigMerge.mergedConfig : mergeBase.columnConfig
  };
  const wasUpdated: boolean = Boolean(columnConfigMerge?.wasUpdated) || Boolean(filterConfigMerge?.wasUpdated) || !isTableColumnConfigDto(parsedColumnConfig);

  return { wasUpdated, mergedConfig: tableConfig };
}
export interface TableConfigMerge extends BaseConfigMerge {
  mergedConfig: TableConfig;
}
export interface BaseConfigMerge {
  mergedConfig: TableConfig | TableColumnConfig | TableFilterConfig;
  /** Whether the config had to been updated from the base-config as root */
  wasUpdated: boolean;
}
